import { render } from "./DonantHome.html?vue&type=template&id=fe8be388&external"
import script from "./DonantHome.vue?vue&type=script&lang=js"
export * from "./DonantHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__